<div [appEnforcePermission]="authConfig.investigationAdminCommentsCreate"
  #investigationAdminCommentsCreate="appEnforcePermission"></div>
<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <div class="ml-16">
        <span>Add comment</span>
        <p class="secondary mb-0">ID: {{this.data?.nefcoNumber || 'Unassigned'}}</p>
      </div>
    </div>
  </kendo-dialog-titlebar>
  <section class="pb-0">
    <form #commentForm="ngForm">
      <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']">
        <kendo-gridlayout-item class="mb-4">
          <kendo-formfield>
            <kendo-label class="asterisk" text="Comment"></kendo-label>
            <kendo-textarea name="commentField" #commentName="ngModel" [(ngModel)]="comment" placeholder="Enter comment"
              fillMode="outline" class="min-height-96" resizable="both" [required]="true"
              appNoWhiteSpace></kendo-textarea>
            <kendo-formerror *ngIf="commentName?.errors">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="commentName?.errors.required">Comment cannot be left blank</span>
            </kendo-formerror>
          </kendo-formfield>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item *ngIf="investigationAdminCommentsCreate?.enabled">
          <div class="k-checkbox-wrap">
            <input name="adminOnly" #adminOnlyCheckBox type="checkbox" kendoCheckBox [(ngModel)]="adminOnly" />
            <kendo-label [for]="adminOnlyCheckBox" class="k-checkbox-label font-weight-500 checkbox-margin mobile-color mb-0"
               text="Admin Only"></kendo-label>
          </div>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </form>
  </section>
  <kendo-dialog-actions layout="end" class="border-top">
    <button kendoButton [size]="'medium'" themeColor="light" (click)="close()">
      Cancel
    </button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="ml-12" (click)="addComment()">
      Save
    </button>
  </kendo-dialog-actions>
</div>
